import { render } from "./car-info-card.vue?vue&type=template&id=080a3696&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./car-info-card.vue?vue&type=script&lang=js"
export * from "./car-info-card.vue?vue&type=script&lang=js"

import "./car-info-card.vue?vue&type=style&index=0&id=080a3696&lang=css"

import exportComponent from "/home/runner/work/provider-frontend/provider-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__